// extracted by mini-css-extract-plugin
export var container = "_5t-1";
export var editor = "_5t-2";
export var resizable = "_5t-3";
export var wrapper = "_5t-0";